// src/components/common/SessionExpiredModal.js

import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import "../../styles/SessionExpiredModal.css";

export default function SessionExpiredModal() {
    const { sessionExpired, resetSessionExpired } = useAuth();
    const navigate = useNavigate();
    const buttonRef = useRef(null);

    // Focus the login button when modal appears
    useEffect(() => {
        if (sessionExpired) {
            setTimeout(() => buttonRef.current?.focus(), 0);
        }
    }, [sessionExpired]);

    // Handle Escape key - redirect to login
    useEffect(() => {
        if (!sessionExpired) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') handleRedirect();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [sessionExpired]); // eslint-disable-line react-hooks/exhaustive-deps

    // The modal is not rendered if the session is not expired.
    if (!sessionExpired) {
        return null;
    }

    const handleRedirect = () => {
        // Reset the state to hide the modal.
        resetSessionExpired();
        // Navigate to the admin-specific login page.
        navigate('/penguin-admin-access');
    };

    return (
        <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="session-expired-title">
            <div className="modal-content">
                <h2 id="session-expired-title">Session Expired</h2>
                <p>
                    For your security, your session has expired due to inactivity.
                    Please log in again to continue.
                </p>
                <button ref={buttonRef} onClick={handleRedirect} className="modal-button">
                    Log In
                </button>
            </div>
        </div>
    );
}
